<template>
    <EngineeringWorkBench></EngineeringWorkBench>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const EngineeringWorkBench = defineAsyncComponent(() =>
    import(
        "../../components/ProjectManagement/EngineeringWorkBench/EngineeringWorkBench.vue"
    )
);

export default {
    name: "Project_EngineerWorkBench", //The name you are in should not equal the name of the component you are importing.
    components: { EngineeringWorkBench, AuthLayout },
};
</script>
